import React from 'react';
import { Web3ReactProvider } from '@web3-react/core';
import { ethers } from 'ethers';
import './App.css';

// Import components
import WalletConnect from './components/WalletConnect';
import ContractInfo from './components/ContractInfo';
import TokenApproval from './components/TokenApproval';
import DepositForm from './components/DepositForm';
import WithdrawForm from './components/WithdrawForm';
import TransferForm from './components/TransferForm';

// Function to get the library for Web3React
const getLibrary = (provider) => {
  // Create a provider with ethers.js v6
  const library = new ethers.BrowserProvider(provider);
  // Set polling interval to reduce network requests
  library.pollingInterval = 12000;
  return library;
};

function App() {
  return (
    <Web3ReactProvider getLibrary={getLibrary}>
      <div className="App">
        <header className="app-header">
          <div className="container">
            <h1 className="app-title">BSC Contract Interaction</h1>
            <p className="app-subtitle">
              Interact with contract: 0x3a27f16decd71d7030fffd1d9e9a2d58d1190d4f on BSC Testnet
            </p>
          </div>
        </header>
        
        <div className="container">
          <div className="card">
            <WalletConnect />
          </div>
          
          <div className="card">
            <ContractInfo />
          </div>
          
          <div className="card">
            <TokenApproval />
          </div>
          
          <div className="transaction-forms">
            <div className="card">
              <DepositForm />
            </div>
            
            <div className="card">
              <WithdrawForm />
            </div>
            
            <div className="card">
              <TransferForm />
            </div>
          </div>
          
          <footer className="app-footer">
            <p>
              &copy; {new Date().getFullYear()} BSC Contract App. All rights reserved.
            </p>
            <p>
              <a 
                href="https://testnet.bscscan.com/address/0x3a27f16decd71d7030fffd1d9e9a2d58d1190d4f"
                target="_blank"
                rel="noopener noreferrer"
              >
                View Contract on BSCScan
              </a>
            </p>
          </footer>
        </div>
      </div>
    </Web3ReactProvider>
  );
}

export default App;
